/**
 * post-chat-message-request.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { ReplyVerifyingMessage } from "../general/reply-message";
import { MessageTag } from "../message-tag";

/**
 * A client transmits a {@link PostChatMessageRequest} to submit a new message 
 * to the chat for the current subject context.
 */
export class PostChatMessageRequest extends ReplyVerifyingMessage
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.REQ_POST_CHAT_MESSAGE;
	public static tag : MessageTag = MessageTag.REQ_POST_CHAT_MESSAGE;

  /**
   * Construct a new {@link PostChatMessageRequest}.
   */
  constructor (
    public message : string
  )
  {
    super();
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/collaboration/post-chat-message-request.ts